export default __webpack_public_path__ + "static/media/0_kia.f2111135.jpg";